import { useQuery } from '@tanstack/react-query';
import api from '../../api';
import type { GcpCert } from '../../types/gcpCert';

const useSingleGcpCert = (gcpCertID: string) => {
  return useQuery({
    queryKey: ['gcpCert', gcpCertID],
    queryFn: () => api.gcpCerts.getSingleCert(gcpCertID),
    select(data) {
      return data.body[0] as GcpCert;
    },
    enabled: !!gcpCertID,
  });
};

export default useSingleGcpCert;
